/**
 * 전체 검색 메뉴 데이터
 * @typedef {object} AllSearchMenuItem
 * @property {string} menuId - 메뉴 ID
 * @property {string} title - 메뉴명
 * @property {number} count - 검색 결과 수
 * @property {Array<AllSearchMenuItem>} [children] - 하위 메뉴
 */


/**
 * 전체 검색 페이지 상단 메뉴 데이터 생성
 * @param {Array<Object>} menus - 전체 메뉴 리스트
 * @param {Object<string, number>} menuCount - 메뉴별 검색 개수
 * @returns {Array<AllSearchMenuItem>}
 */
export const setMakeAllSearchData = (menus, menuCount) => {
    const result = [];
    const walk = (nodes) => {
        nodes.forEach((node) => {
            if (!node || typeof node !== "object") return;
            const count = menuCount[node.menuId];
            if (count) {
                result.push({
                    ...node,
                    count,
                });
            }

            if (node.children && node.children.length > 0) {
                walk(node.children);
            }
        });
    };
    walk(menus);
    return result;
}
